
Array.prototype.my_prop_filter = function(filter_object) {
  var keys = Object.keys(filter_object);
  var result = this;
  keys.forEach((k) => {
    if (filter_object[k].value !== "") {
      if (!filter_object[k].like) {
        result = result.filter((r) => r[k] == filter_object[k].value);
      } else {
        result = result.filter((r) => {
          if (r[k] == null) {
            return false;
          }
          var match = r[k].match(filter_object[k].value);
          if (match) {
            return true;
          } else {
            return false;
          }
        });
      }
    }
  });
  return result;
};

